var map = {
	"./barack_album_2008_force_graph": 504,
	"./barack_album_2008_force_graph.json": 504,
	"./control_force_graph": 96,
	"./control_force_graph.json": 96,
	"./obama_v_others_2007_2011_graph": 213,
	"./obama_v_others_2007_2011_graph.json": 213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89;